import React from 'react';

type Props = {
  disabled?: boolean;
  fluid?: boolean;
  outline?: boolean;
  primary?: boolean;
  link?: boolean;
  secondary?: boolean;
  text?: boolean;
  onClick: () => void;
};

const Button: React.FC<Props> = props => (
  <div
    className={
      [
        'btn',
        props.fluid && 'btn-fluid',
        props.outline && 'btn-outline',
        props.outline && props.secondary && 'btn-secondary-outline',
        props.primary && 'btn-primary',
        props.text && 'btn-text',
        props.link && 'btn-link',
        props.disabled && 'is-disabled',
      ]
        .filter(x => x)
        .join(' ') + ` ${!props.disabled ? 'cursor-pointer' : ''}`
    }
    onClick={() => !props.disabled && props.onClick()}>
    {props.children}
  </div>
);

Button.defaultProps = {
  disabled: false,
  fluid: false,
  outline: false,
  primary: false,
  secondary: false,
  text: false,
};

export default Button;
